<div class="sign-in-page-container">
  <div class="title-container">
    <span class="login-title desktop-hide">{{ (isLoginAsGuest ? 'fspro.front.header.login.guest-title' : 'fspro.front.header.login.title') | translate }}</span>
    <img src="assets/images/logo-festival-scope-pro-white.svg" alt="Festival Scope Pro Logo" class="logo">
    <span class="catchphrase mobile-hide">{{ 'fspro.front.header.login.catchphrase' | translate }}</span>
  </div>
  <div class="right-container">
    <span class="login-title mobile-hide">{{ (isLoginAsGuest ? 'fspro.front.header.login.guest-title' : 'fspro.front.header.login.title') | translate }}</span>
    <div class="sign-in-card">
      @if (!isVerifyingCode && !mustVerifyCode && !isLoginAsGuest) {
        <form
          class="sign-in-form"
          [formGroup]="loginForm"
          (ngSubmit)="onLogin()"
        >
          <div class="form-group">
            <label class="form-label" for="username">{{ 'fspro.front.header.login.label.email' | translate }}</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                autocomplete="off"
                type="email"
                formControlName="username"
                name="username"
              >
            </mat-form-field>
          </div>
          <div class="form-group">
            <div class="password-label-container">
              <label class="form-label" for="password">{{ 'fspro.front.header.login.label.password' | translate }}</label>
              <a
                class="forgot-password-link"
                routerLink="/forgotten-password"
              >{{'fspro.front.header.login.label.forget_password' | translate}}</a>
            </div>
            <mat-form-field appearance="outline">
              <input
                matInput
                autocomplete="off"
                type="password"
                formControlName="password"
                name="password"
              >
            </mat-form-field>
          </div>
          @if (isLoginFailed) {
            <div class="error-container">
              @if (loginErrorMessage === 'Not confirmed') {
                <span>Please activate your account before signing in. Click <a class="error-link" (click)="sendActivationEmail()">here</a> to receive an email with instructions.</span>
              } @else if (loginErrorMessage === 'Your account has been locked') {
                <span>Your account has been suspended. Please contact <a class="error-link" href="mailto:feedback@festivalscope.com">feedback&#64;festivalscope.com</a> for more information.</span>
              } @else if (loginErrorMessage === 'JWT Token not found') {
                <span>Your email or password is invalid.</span>
              } @else {
                <span [innerHTML]="loginErrorMessage"></span>
              }
            </div>
          }
          <button mat-flat-button type="submit" [disabled]="isLoadingUserSignIn" class="login-button">
            <div class="button-label-icon">
              @if (isLoadingUserSignIn) {
                <mat-spinner [color]="'primary'" [diameter]="20" class="spinner"></mat-spinner>
              }
              <span> {{ 'fspro.front.header.login.label.sign-in' | translate }}</span>
            </div>
          </button>
          <div class="sso-buttons-container">
            @for (provider of oidcProviders; track provider.name) {
              <button mat-stroked-button type="button" [disabled]="isLoadingUserSignIn" class="sso-button" (click)="loginWithOidc(provider.name)">
                <span class="sso-button-content">
                  @if (isLoadingUserSignIn) {
                    <mat-spinner [color]="'primary'" [diameter]="20" class="spinner"></mat-spinner>
                  } @else {
                    <img [src]="provider.logo" alt="" aria-hidden="true" class="sso-provider-logo">
                  }
                  <span class="sso-button-label">{{ 'fspro.front.authentication.sso.sign_in_with' | translate: { provider: provider.label } }}</span>
                </span>
              </button>
            }
          </div>
          <div class="links-container">
            <a
              (click)="isLoginAsGuest = true"
              class="no-account-link"
            >{{'fspro.front.header.login.label.login_guest' | translate}}</a>
            <a
              routerLink="/sign-up"
              class="no-account-link"
            >{{'fspro.front.header.login.label.no_account' | translate}}</a>
          </div>
        </form>
      } @else if (isLoginAsGuest) {
        <form class="sign-in-form" [formGroup]="loginAsGuestForm" (ngSubmit)="loginAsGuest()">
          <div class="form-group">
            <label class="form-label" for="username">{{ 'fspro.front.header.login.label.email' | translate }}</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                autocomplete="off"
                type="email"
                formControlName="username"
                name="username"
              >
            </mat-form-field>
          </div>
          @if (displayLoginAsGuestMessage) {
            <span class="verification-title" [innerHTML]="'fspro.front.header.login.label.login_guest_message' | translate: { email: loginAsGuestForm.get('username').value }"></span>
          }
          @if (loginAsGuestErrorMessage) {
            <div class="error-container">
              <span [innerHTML]="loginAsGuestErrorMessage"></span>
            </div>
          }
          @if (!displayLoginAsGuestMessage) {
            <button mat-flat-button type="submit" [disabled]="isLoadingGuestSignIn" class="login-button">
              <div class="button-label-icon">
                @if (isLoadingGuestSignIn) {
                  <mat-spinner [color]="'primary'" [diameter]="20" class="spinner"></mat-spinner>
                }
                <span> {{ 'fspro.front.header.login.label.sign-in' | translate }}</span>
              </div>
            </button>
          }
          <div class="links-container">
            <a
              routerLink="/sign-up"
              class="no-account-link"
            >{{'fspro.front.header.login.label.no_account' | translate}}</a>
            <a
              (click)="onGoBack()"
              class="no-account-link"
            >{{'fspro.front.header.login.label.go_back' | translate}}</a>
          </div>
        </form>
      } @else if (mustVerifyCode) {
        <form class="sign-in-form" [formGroup]="verificationCodeForm" (ngSubmit)="verifyCode()">
          <span class="verification-title">{{ 'fspro.front.header.login.verification-display' | translate }}</span>
          <fspro-code-input formControlName="verificationCode" [length]="6"></fspro-code-input>
          <div *ngIf="isLoginFailed" class="error-container">
            @if (loginErrorMessage === 'Too many requests, your account has been locked.') {
              <span>'Your account has been suspended. Please contact <a class="error-link" href="mailto:feedback@festivalscope.com">feedback&#64;festivalscope.com</a> for more information.</span>
            } @else {
              <span [innerHTML]="loginErrorMessage"></span>
            }
          </div>
          <button class="login-button" mat-flat-button [disabled]="isVerifyingCode || verificationCodeForm.invalid">
            <div class="button-label-icon">
              @if (isVerifyingCode) {
                <mat-spinner [color]="'primary'" [diameter]="20" class="spinner"></mat-spinner>
              }
              <span> {{ 'fspro.front.header.login.label.verify' | translate }}</span>
            </div>
          </button>
          <a
            (click)="onGoBack()"
            class="no-account-link verification-back-link"
          >{{'fspro.front.header.login.label.go_back' | translate}}</a>
        </form>
      }

    </div>
  </div>
</div>
